<template>
  <div class="aviso mt-5 mb-3">
    <p>
      <strong>AVISO DE CONFIDENCIALIDAD</strong>: Toda la información incluida en este cuestionario contiene información confidencial o legalmente privilegiada de The Research Office y de nuestros clientes, la cual está protegida por Ley.
      La misma prohíbe que se divulgue la información aquí contenida a ninguna persona o entidad sin el consentimiento específico para ello y por escrito, de la persona quien refiere la información. La información está
      destinada sólo para el uso de las personas autorizadas. Si usted no es la persona autorizada, de tener este cuestionario, se le notifica que está estrictamente prohibido fotocopiar, revelar, distribuir o tomar cualquier
      acción basada en el contenido de la información de esta comunicación. Si usted recibió este cuestionario por error, agradeceremos que lo notifique a nuestra compañía, llamando al 787-622-4500.
    </p>
  </div>
</template>

<script>

export default {
  name: 'AvisoConfi',
}
</script>
